import $ from 'jquery'

export default function initCookieConsent() {
  function getCookie(name) {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`)
    return v ? v[2] : null
  }
  function setCookie(name, value, days) {
    const d = new Date()
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
    document.cookie = `${name}=${value};path=/;expires=${d.toGMTString()}`
  }
  window.onload = function cookieC() {
    if (getCookie('cookieConsent') !== 'on') {
      $('.c-cookie-consent').show()
    }
  }
  $('[data-close-cookie]').on('click', (e) => {
    e.preventDefault()
    setCookie('cookieConsent', 'on', 14)
    $('.c-cookie-consent').remove()
  })
}
